import script from "./EmailDeliveryHealth.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailDeliveryHealth.vue?vue&type=script&setup=true&lang=js"

import "./EmailDeliveryHealth.vue?vue&type=style&index=0&id=67337646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67337646"]])

export default __exports__